import {h} from 'preact';
import LinksToSocialNetworks from "../../components/LinksToSocialNetworks/LinksToSocialNetworks";
import CasesGrid from "../../components/CasesGrid/CasesGrid";
import FeedbackSlider from "../../components/FeedbackSlider/FeedbackSlider";
import styles from "./style.scss"
import ReturnBack from "./ReturnBack";

const Success = () => {
  return (
      <main id="main-container" className={styles.wrapper} main-attr>
          <ReturnBack></ReturnBack>

          <h1>Платные образовательные услуги</h1>
          <h2>Документы</h2>
          <ul className={'pdfLinks'}>
              {/*<li>*/}
              {/*    <a target="_blank" href={'/assets/documents/platnie/1_polozenie-platnye-uslugi.pdf'}>Положение о*/}
              {/*        порядке оказания платных образовательных услуг*/}
              {/*    </a>*/}
              {/*</li>*/}
              <li>
                  <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={'/assets/documents/mih/8-polozenie-o-poryadke-okazaniya-platnyx-obrazovatelnyx-uslug.pdf'}
                  >
                      Положение о порядке оказания платных образовательных услуг
                  </a>
              </li>
              <li>
                  <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={'/assets/documents/mih/9-prikaz-ob-utverzdenii-stoimosti-obuceniya-nov-programma-24-25g.pdf'}
                  >
                      Приказ об утверждении стоимости обучения по Дополнительной общеобразовательной общеразививающей
                      программе 24-25г
                  </a>
              </li>

              <li>
                  <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={'https://disk.yandex.by/i/Sg_pIQr0x3twJg'}
                  >
                      Стоимость лицензия DevOps
                  </a>
              </li>
              <li>
                  <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={'https://disk.yandex.by/i/JZa0M2iBI8DTxQ'}
                  >
                      Стоимость обучение DevOps
                  </a>
              </li>
              <li>
                  <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={'https://disk.yandex.by/i/SVRxF0aA1SNuMw'}
                  >
                      Стоимость трудоустройство DevOps
                  </a>
              </li>
          </ul>
      </main>
  );
};

export default Success;